const state = {
  plainusers: [],
  users: [],
  user: {}
};

export default {
  namespaced: true,
  state,
  mutations: {
    setUsers(state, users) {
      state.users = users;
    },
    setUser(state, user) {
      state.user = user;
    },
    setPlainUsers(state, plainusers) {
      state.plainusers = plainusers;
    }
  },
  actions: {
    fetchUsers({ commit }, payload) {
      const { dontPaginate, filter, page, paginationcount } = payload;
      if (!!dontPaginate || typeof dontPaginate === 'undefined') {
        commit('SET_LOADING', true, { root: true });
        if (!!filter || typeof filter === 'undefined') {
          return axios
            .get('api/v1/user', {
              params: { page: payload.page, filter: filter, paginationcount: paginationcount }
            })
            .then(response => {
              commit('setUsers', response.data);
            })
            .catch(error => {
              if (error.response.status == 403) {
                commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              }
            })
            .finally(() => {
              commit('SET_LOADING', false, { root: true });
            });
        }
        return axios
          .get('api/v1/user', { params: { page: payload.page, paginationcount: paginationcount } })
          .then(response => {
            commit('setUsers', response.data);
          })
          .catch(error => {
            if (error.response.status == 403) {
              commit(
                'SET_SNACK_BAR',
                {
                  message: error.response.data['message'],
                  color: 'error'
                },
                { root: true }
              );
            }
          })
          .finally(() => {
            commit('SET_LOADING', false, { root: true });
          });
      } else {
        if (!!filter || typeof filter === 'undefined') {
          return axios
            .get('api/v1/user', { params: { paginate: 0, filter: filter } })
            .then(response => {
              commit('setPlainUsers', response.data);
            })
            .finally(() => commit('SET_LOADING', false, { root: true }));
        }
        return axios.get('api/v1/user', { params: { paginate: 0 } }).then(response => {
          commit('setPlainUsers', response.data);
        });
      }
    },
    getUser({ commit }, payload) {
      return axios
        .get(`api/v1/user/${payload.id}`)
        .then(response => {
          commit('setUser', response.data);
        })
        .catch(error => {
          if (error.response.status == 403) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
            commit('setUser', {});
          }
        })
        .catch(error => {
          if (error.response.status == 404) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
            commit('setUser', {});
          }
        });
    }
  }
};
